import { create } from "zustand";
import { PaginationParams } from "~/services/type";
import { TTemplate } from "~/types/template";

type State = {
  modalState: {
    openTemplate: boolean;
    templateId?: string;
  };
  filters: PaginationParams;
  selectedTemplate: TTemplate | null;
};

type Actions = {
  openTemplateModal: (templateId?: string) => void;
  closeTemplateModal: () => void;
  setSelectedTemplate: (template: TTemplate | null) => void;
  setFilters: (filters: PaginationParams) => void;
};

export const useNotificationStore = create<State & Actions>()((set) => ({
  modalState: {
    openTemplate: false,
  },
  filters: {
    page: 1,
    limit: 10,
    search: "",
    sort: "createdAt",
    order: "desc",
  },
  selectedTemplate: null,
  openTemplateModal: (templateId?: string) =>
    set(() => ({
      modalState: {
        openTemplate: true,
        templateId,
      },
    })),
  closeTemplateModal: () =>
    set(() => ({
      modalState: {
        openTemplate: false,
        templateId: undefined,
      },
    })),
  setSelectedTemplate: (template) =>
    set(() => ({
      selectedTemplate: template,
    })),
  setFilters: (filters) =>
    set((state) => ({
      filters: {
        ...state.filters,
        ...filters,
      },
    })),
}));
